const PanelElement = require("../elements/panel.js");
const html = require("choo/html");
const Button = require("../elements/button.js");
const ButtonIcon = require("../elements/buttonicon.js");
const InputText = require("../elements/inputtext.js");
const CarouselElement = require("../elements/carousel.js"); // Ensure you have imported CarouselElement

const scenesPerPage = 4; // You can adjust this number based on your preference

function paginateScenes(scenes, scenesPerPage) {
  const pages = [];
  for (let i = 0; i < scenes.length; i += scenesPerPage) {
    const page = scenes.slice(i, i + scenesPerPage);
    pages.push(page);
  }
  if (scenes.length % scenesPerPage === 0) {
    pages.push([]);
  }
  return pages;
}

module.exports = function LevelsPanel(state, emit) {
  function RenameSceneInput(scene) {
    return InputText({
      value: scene.metadata.id,
      extraStyle: "width:70%; margin-right:var(--size-4)",
      inputId: "rename-scene-input",
      autoFocus: true,
      onFocus: (e) => {
        // Select all text when entering rename mode
        try {
          e.target.select();
        } catch (err) {}
      },
      onBlur: () => emit("stop-renaming-scene"),
      onInput: (e) => emit("update-scene-name", e.target.value.slice(0, 28)),
      onKeyDown: (e) => {
        if (e && (e.key === "Enter" || e.keyCode === 13)) {
          emit("stop-renaming-scene");
        }
      },
    });
  }

  function SceneButton(scene, index) {
    const isCurrentScene = state.currentScene === scene;
    let color = isCurrentScene ? "purple" : "mediumgrey";
    if (state.renamingScene && isCurrentScene) {
      return RenameSceneInput(scene);
    }
    return Button({
      text: scene.metadata.id,
      id: `level-button-${scene.metadata.id}`,
      color,
      type: "icon-aligned",
      size: "small",
      onMouseOver: () => {
        if (
          state.draggingSceneId &&
          state.draggingSceneId !== scene.metadata.id
        ) {
          emit("swap-scenes", state.draggingSceneId, scene.metadata.id);
        }
      },
      onMouseDown: (e) => {
        const mini = Button({
          color: isCurrentScene ? "purple" : "mediumgrey",
          text: `${index + 1}: ${scene.metadata.id}`,
          type: "fullwidth",
          size: "small",
        });
        emit("start-drag", mini, e);
        emit("start-moving-scene", scene.metadata.id);
      },
      onClick: () => {
        if (isCurrentScene) {
          emit("rename-scene", scene.metadata.id);
        } else {
          emit("complete-drag-action");
          emit("load-scene", index);
        }
      },
    });
  }

  function EditSceneButton(scene) {
    if (state.levelLoading) {
      return null;
    }
    if (state.currentScene === scene) {
      return ButtonIcon({
        icon: "pencil",
        onClick: () => {
          if (state.renamingScene) {
            emit("stop-renaming-scene");
          } else {
            emit("rename-scene", scene.metadata.id);
          }
        },
        size: "medium",
        id: "rename-scene-button",
      });
    }
    return null;
  }
  if (state.currentScenePage === null) {
    // set the current scene page to the one that contains the current scene
    const currentSceneIndex = state.project.scenes.findIndex(
      (scene) => scene.metadata.id === state.currentScene.metadata.id
    );
    state.currentScenePage = Math.floor(currentSceneIndex / scenesPerPage);
  }
  const numberOfScenes = state.project.scenes.length;
  const isNextPage =
    state.currentScenePage < Math.floor(numberOfScenes / scenesPerPage);
  const plusButton = isNextPage
    ? null
    : Button({
        text: "NEW LEVEL",
        type: "fullwidth",
        id: "new-level-button",
        onClick: () => emit("create-new-scene"),
        size: "medium",
      });

  const scenePages = paginateScenes(state.project.scenes, scenesPerPage).map(
    (page, pageIndex) => html`
      <div style="display: flex; flex-direction: column;" class="info">
        ${page.map(
          (scene, sceneIndex) => html`
            <div style="display: flex; margin-bottom: var(--size-2);">
              ${SceneButton(scene, pageIndex * scenesPerPage + sceneIndex)}
              ${EditSceneButton(scene)}
            </div>
          `
        )}
        <div style="display: flex; margin-top: var(--size-4);">
          ${plusButton}
        </div>
      </div>
    `
  );

  // Handle change in selected item for carousel
  function handleCarouselChange(index) {
    emit("select-scene-page", index); // You might need to handle this event in your state management
  }

  const onMouseOverNext = () => {
    if (state.draggingSceneId && isNextPage) {
      const nextSceneIndex = (1 + state.currentScenePage) * scenesPerPage;
      if (!state.project.scenes[nextSceneIndex]) {
        return;
      }
      const nextSceneId = state.project.scenes[nextSceneIndex].metadata.id;
      emit("select-scene-page", state.currentScenePage + 1);
      emit("swap-scenes", state.draggingSceneId, nextSceneId);
    }
  };
  let previousPageDropArea = html``;
  const previousSceneIndex = state.currentScenePage * scenesPerPage - 1;
  let onMouseOverPrevious = () => {};
  if (previousSceneIndex >= 0) {
    const previousSceneId =
      state.project.scenes[previousSceneIndex].metadata.id;
    const onMouseOverPrevious = () => {
      if (state.draggingSceneId) {
        emit("select-scene-page", state.currentScenePage - 1);
        emit("swap-scenes", state.draggingSceneId, previousSceneId);
      }
    };
    previousPageDropArea = html` <div
      onmouseover=${onMouseOverPrevious}
      style="position:absolute; left: 0; top:0; width:100%; height:6%; z-index:100;"
    ></div>`;
  }
  const nextPageDropArea = html` <div
    onmouseover=${onMouseOverNext}
    style="position:absolute; left: 0; bottom:12%; width:100%; height:15%; z-index:100;"
  ></div>`;

  // Return the Panel with Carousel
  return PanelElement({
    title: "Levels",
    children: [
      nextPageDropArea,
      previousPageDropArea,
      CarouselElement({
        selectedItem: state.currentScenePage || 0,
        items: scenePages,
        onChange: handleCarouselChange,
      }),
    ],
  });
};
